import {axios} from '../Api';

class AccountService {
    login = async (email, password) => {
        const params = new URLSearchParams();
        params.append('email', email);
        params.append('password', password);
        const response = await axios.post('/login', params);
        return response.data;
    };

    logout = () => {
        return axios.post('/logout');
    };

    register = (data) => {
        return axios.post('/register', data);
    };

    resetPassword = (data) => {
        return axios.post('/resetPassword', data);
    };

    forgotPassword = (data) => {
        return axios.post('/forgotPassword', data);
    };

    sendFeedback = (data) => {
        return axios.post('/app/api/feedback', data);
    };

}

export default new AccountService();



// WEBPACK FOOTER //
// ./src/services/AccountService.js